module.exports = __webpack_public_path__ + "img/man.74ed40af.png";